@if (onlyButton) {
  <button
    mat-raised-button
    color="primary"
    disableRipple="true"
    element-ref
    #elementRef="elementRef"
    (click)="pickImage(elementRef)"
    i18n
    [attr.data-testid]="'image-picker-only-button'"
  >
    @if (value) {
      更換
    } @else {
      上傳
    }
    圖片
  </button>
}

@if (!autoSize && !onlyButton) {
  <div
    matRipple
    class="picture mat-elevation-z4"
    element-ref
    #elementRef="elementRef"
    [style.background-image]="backgroundImage(value | imageType)"
    (click)="pickImage(elementRef)"
    [attr.data-testid]="'image-picker-fixed-size'"
  >
    <div class="btns">
      <button
        mat-raised-button
        color="primary"
        disableRipple="true"
        i18n
        [attr.data-testid]="'image-picker-change-button'"
      >
        @if (value) {
          更換
        } @else {
          上傳
        }
        圖片
      </button>
      @if (value) {
        <button
          mat-raised-button
          color="warn"
          disableRipple="true"
          (click)="deleteImage($event)"
          i18n
          [attr.data-testid]="'image-picker-delete-button'"
        >
          刪除圖片
        </button>
      }
    </div>
  </div>
}

@if (autoSize && !onlyButton) {
  <div
    class="auto-size picture mat-elevation-z4"
    element-ref
    #elementRef="elementRef"
    (click)="pickImage(elementRef)"
    [attr.data-testid]="'image-picker-auto-size'"
  >
    @if (value) {
      <img
        [src]="value | imageType"
        [attr.data-testid]="'image-picker-preview'"
      />
    }
    <div class="btns">
      <button
        mat-raised-button
        color="primary"
        disableRipple="true"
        i18n
        [attr.data-testid]="'image-picker-change-button-auto'"
      >
        @if (value) {
          更換
        } @else {
          上傳
        }
        圖片
      </button>
      @if (value) {
        <button
          mat-raised-button
          color="warn"
          disableRipple="true"
          (click)="deleteImage($event)"
          i18n
          [attr.data-testid]="'image-picker-delete-button-auto'"
        >
          刪除圖片
        </button>
      }
    </div>
  </div>
}
